import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import FalconSmileReview from './FalconSmile-review';
import FalconSmileAppointmentProposal from './FalconSmile.appointment-proposal';

const rootElement = document.getElementById('root');
const dentalLiveElement = document.querySelector('dental-live');
const mountElement = rootElement || dentalLiveElement;

if (mountElement) {
  const params = new URLSearchParams(window.location.search);
  const apiKey =
    params.get('apiKey') ||
    params.get('api-key') ||
    mountElement.getAttribute('api-key') ||
    mountElement.getAttribute('data-api-key') ||
    mountElement.dataset.apiKey ||
    '';
  const parentOrigin =
    params.get('parentOrigin') ||
    mountElement.dataset.parentOrigin ||
    '';

  const root = ReactDOM.createRoot(mountElement);
  const pathname = window.location.pathname.replace(/\/+$|^\/$/, '');
  const page = params.get('page') || (pathname === '/dental-review' ? 'dental-review' : '');
  console.log(apiKey);
  root.render(
    <React.StrictMode>

      {page === 'dental-review' ? (
        <FalconSmileReview config={{ apiKey, parentOrigin }} />
      ) : (
        <FalconSmileAppointmentProposal config={{ apiKey, parentOrigin }} />
      )}
    </React.StrictMode>
  );
}
